import type { StudentWorkspace } from '@/entities/student-workspace'
import { useStore } from '@/store/useStore'

export type StudentWorkspacePlantFacts = Readonly<Pick<
  StudentWorkspace,
  | 'rewardClaims'
  | 'assessmentSessions'
  | 'formativeTaskSessions'
  | 'completedTasks'
  | 'taskCompletedAt'
  | 'attempts'
>>

export function readStudentWorkspaceFacts(studentId: string): StudentWorkspacePlantFacts | null {
  const workspace = useStore.getState().workspaces[studentId]
  if (!workspace) return null
  return {
    rewardClaims: workspace.rewardClaims,
    assessmentSessions: workspace.assessmentSessions,
    formativeTaskSessions: workspace.formativeTaskSessions,
    completedTasks: workspace.completedTasks,
    taskCompletedAt: workspace.taskCompletedAt,
    attempts: workspace.attempts,
  }
}
